export class ScheduleRequest
{
    idsPortoOrigem: string;
    idsPortoDestino: string;
    dataInicio: Date;
    dataFim: Date;
    servico: string;
    tipoPeriodo: string;
}